<template>
  <div class="znty-step2-layer">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="投资推荐" name="tztj">
        <div class="tab-content-container">
          <touzituijian />
        </div>
      </el-tab-pane>
      <el-tab-pane label="市场时讯建议" name="scsxjy">
        <div class="tab-content-container">
          <shichangshixunjianyi @next="handleNextClick" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="压力测试" name="ylcs">
        <div class="tab-content-container">
          <yaliceshi @next="handleNextClick" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="构建投资组合" name="gjtzzh">
        <div class="tab-content-container">
          <goujiantouzizuhe @next="handleNextClick" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="投顾报告" name="tgbg">
        <div class="tab-content-container">
          <tougubaogao />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Shichangshixunjianyi from './shichangshixunjianyi.vue'
import touzituijian from './touzituijian.vue'
import shichangshixunjianyi from './shichangshixunjianyi.vue'
import yaliceshi from './yaliceshi.vue'
import goujiantouzizuhe from './goujiantouzizuhe.vue'
import tougubaogao from './tougubaogao.vue'

export default {
  name: '',
  components: {
    touzituijian,
    Shichangshixunjianyi,
    shichangshixunjianyi,
    yaliceshi,
    goujiantouzizuhe,
    tougubaogao
  },
  props: {},
  data () {
    return {
      activeName: 'tztj'
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    handleClick (tab) {
      console.log('点击标签：', tab.name)
      // 需要做判断，不能继续点击后面的标签, 根据接口返回的data判断目前做到了步骤
      if (tab.name === 'tgbg') {
        return
      }
    },
    handleNextClick (data) {
      let loading = this.$loading({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      setTimeout(() => {
        loading.close()
        this.$message({ message: '操作成功', type: 'success' })
        this.activeName = data
      }, 200);

    }
  }
}
</script>

<style scoped lang="less">
.znty-step2-layer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 优化Tabs样式，实现横向滚动
:deep(.el-tabs) {
  height: 100%;
  display: flex;
  flex-direction: column;

  // 标签栏容器
  .el-tabs__header {
    background: rgba(0, 0, 0, 0.2);
    padding: 0;
    margin: 0;
    border-bottom: 1px solid rgba(21, 73, 243, 0.3);
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;

    // 隐藏滚动条但保留滚动功能
    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    // 标签项
    .el-tabs__nav-wrap {
      overflow: visible;

      .el-tabs__nav {
        padding: 0 20px;
        white-space: nowrap;
      }
    }

    // 单个标签样式
    .el-tabs__item {
      color: #b8c4e0;
      font-size: 16px;
      padding: 0 30px;
      height: 60px;
      line-height: 60px;
      margin-right: 0;
      border-bottom: 3px solid transparent;

      &.is-active {
        color: #1549F3;
        border-bottom-color: #1549F3;
        font-weight: bold;
      }

      &:hover {
        color: #1549F3;
      }
    }

    // 指示器样式
    .el-tabs__active-bar {
      background-color: #1549F3;
      height: 3px;
    }
  }

  // 内容区域
  .el-tabs__content {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(21, 73, 243, 0.5);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(21, 73, 243, 0.7);
    }
  }

  // 确保每个标签页内容容器样式
  .el-tab-pane {
    height: 100%;
  }
}
</style>
